var map = {
	"./CaretRight.svg": 63943,
	"./Excel.svg": 84527,
	"./PowerPoint.svg": 93609,
	"./Teams.svg": 97232,
	"./add-colored.svg": 53198,
	"./add.svg": 46019,
	"./aha-asterisk.svg": 70503,
	"./aha-backstage.svg": 55928,
	"./aha-bell.svg": 27660,
	"./aha-chart.svg": 89893,
	"./aha-chat-circle.svg": 64826,
	"./aha-click.svg": 71817,
	"./aha-close.svg": 55773,
	"./aha-device-mobile.svg": 55832,
	"./aha-dots-vertical.svg": 44198,
	"./aha-drag.svg": 40045,
	"./aha-duplicate.svg": 35502,
	"./aha-edit.svg": 20751,
	"./aha-eye-slash.svg": 42490,
	"./aha-fire.svg": 56447,
	"./aha-globe-simple.svg": 72097,
	"./aha-hand-pointing.svg": 94183,
	"./aha-hourglass-high.svg": 37816,
	"./aha-info.svg": 25267,
	"./aha-magnifier-v2.svg": 99486,
	"./aha-magnifier.svg": 37937,
	"./aha-move.svg": 71104,
	"./aha-music-notes.svg": 88884,
	"./aha-play.svg": 31973,
	"./aha-presentation-chart-first.svg": 37561,
	"./aha-presentation-chart.svg": 85864,
	"./aha-question.svg": 19427,
	"./aha-question2.svg": 88411,
	"./aha-remote.svg": 32261,
	"./aha-reset.svg": 91244,
	"./aha-share-network.svg": 20049,
	"./aha-share.svg": 73508,
	"./aha-shuffle.svg": 84902,
	"./aha-sign-out.svg": 74771,
	"./aha-smiley.svg": 6325,
	"./aha-trash.svg": 41115,
	"./aha-user-circle.svg": 52055,
	"./aha-user-circle2.svg": 81463,
	"./aha-user-plus.svg": 97939,
	"./aha-users-three.svg": 6874,
	"./aha-users.svg": 26421,
	"./ai-generate-button-disabled.svg": 69282,
	"./ai-generate-button.svg": 92357,
	"./ai-sparkle.svg": 80021,
	"./analytical.svg": 79672,
	"./answered.svg": 38543,
	"./arrow-clock-wise-rtl.svg": 10652,
	"./arrow-clock-wise.svg": 78333,
	"./arrow-left.svg": 71793,
	"./arrow-no-tail-black.svg": 43620,
	"./arrow-no-tail-white.svg": 35874,
	"./arrow-no-tail.svg": 58790,
	"./arrow-square-out-v2.svg": 16021,
	"./arrow-square-out.svg": 17180,
	"./arrow-tail.svg": 6520,
	"./arrow.svg": 42669,
	"./arrows-clock-wise.svg": 49234,
	"./arrows-exchange.svg": 12798,
	"./audience-feedback.svg": 19860,
	"./audience.svg": 62872,
	"./award.svg": 63365,
	"./b-key.svg": 47258,
	"./backstage.svg": 21731,
	"./banned.svg": 68726,
	"./bar-chart-square.svg": 74246,
	"./bill-v2.svg": 51782,
	"./bill.svg": 87321,
	"./bin-empty.svg": 99817,
	"./blink.svg": 31264,
	"./bottom_direction.svg": 12909,
	"./brainstorm-v2-dark.svg": 20763,
	"./brainstorm-v2.svg": 96346,
	"./brainstorm-white.svg": 4425,
	"./brainstorm.svg": 93653,
	"./bring-forward.svg": 54934,
	"./bring-to-front.svg": 1830,
	"./c-key.svg": 72731,
	"./caret-down.svg": 70415,
	"./categorise-v2-dark.svg": 8008,
	"./categorise-v2.svg": 53787,
	"./categorise-white.svg": 62338,
	"./categorise.svg": 97510,
	"./change-text-color.svg": 15248,
	"./chat-canvas-noti.svg": 6234,
	"./chat-canvas.svg": 54669,
	"./chat.svg": 96780,
	"./chat2.svg": 18806,
	"./chatGPT-white.svg": 61935,
	"./chatGPT.svg": 15871,
	"./check-circle-o.svg": 57211,
	"./check.svg": 5070,
	"./chevron-down-new.svg": 47745,
	"./chevron-down.svg": 38540,
	"./chevron-right-2.svg": 89495,
	"./chevron-right.svg": 10398,
	"./chevron-up-new.svg": 86842,
	"./circle-audience-color.svg": 26423,
	"./circle-audience.svg": 65281,
	"./circle-check-mark-color.svg": 85795,
	"./circle-check-mark.svg": 88669,
	"./circle-check-with-border.svg": 36757,
	"./circle-check.svg": 13749,
	"./circle-heart-color.svg": 28663,
	"./circle-heart.svg": 57281,
	"./circle-star-color.svg": 32793,
	"./circle-star.svg": 9355,
	"./circle-submission-color.svg": 70481,
	"./circle-submission.svg": 66019,
	"./clear.svg": 37337,
	"./clip.svg": 32100,
	"./close-o.svg": 7454,
	"./close-round.svg": 16837,
	"./close-small.svg": 70000,
	"./close-v2.svg": 71799,
	"./close.svg": 55306,
	"./cloud-colored.svg": 32376,
	"./cloud-import.svg": 50993,
	"./cloud.svg": 53973,
	"./coin.svg": 6489,
	"./comment.svg": 23581,
	"./community-v2.svg": 62986,
	"./community.svg": 5669,
	"./connection-error.svg": 67871,
	"./connection-good.svg": 22324,
	"./connection-unstable.svg": 27403,
	"./content-v2-dark.svg": 76655,
	"./content-v2.svg": 16662,
	"./content-w.svg": 90509,
	"./content.svg": 69193,
	"./copy-b.svg": 82172,
	"./copy-icon.svg": 29697,
	"./copy-regular.svg": 67310,
	"./copy-to-another-slide.svg": 57799,
	"./copy-to-workspace.svg": 15761,
	"./copy.svg": 47661,
	"./correct-order-v2-dark.svg": 36057,
	"./correct-order-v2.svg": 27332,
	"./correct-order-w.svg": 60939,
	"./correct-order.svg": 49043,
	"./correct.svg": 69200,
	"./countdown-timer-w.svg": 13327,
	"./countdown-timer.svg": 41799,
	"./creative.svg": 28545,
	"./ctrl-key.svg": 22291,
	"./cut.svg": 75038,
	"./d-key.svg": 82388,
	"./default-thumbnail.svg": 25130,
	"./default_direction.svg": 1371,
	"./delete-key.svg": 94765,
	"./delete.svg": 86343,
	"./delete2.svg": 58311,
	"./dislike.svg": 80135,
	"./document-dark.svg": 9078,
	"./document-excel.svg": 63315,
	"./document-v2-dark.svg": 88371,
	"./document-v2.svg": 8802,
	"./document-w.svg": 75105,
	"./document.svg": 52637,
	"./documents.svg": 55636,
	"./dollar-currency-v2.svg": 68437,
	"./donut-w.svg": 22594,
	"./donut.svg": 87926,
	"./down.svg": 63430,
	"./download-2.svg": 67223,
	"./download.svg": 59230,
	"./draw.svg": 73212,
	"./duplicate.svg": 60897,
	"./duplicated.svg": 26591,
	"./edit-2.svg": 32187,
	"./edit-outline.svg": 24835,
	"./edit.svg": 94458,
	"./embed-dark.svg": 95558,
	"./embed-v2-dark.svg": 16067,
	"./embed-v2.svg": 2514,
	"./embed.svg": 69965,
	"./empty-photo.svg": 30034,
	"./error-circle-o.svg": 59629,
	"./error.svg": 63668,
	"./export-2.svg": 19229,
	"./export.svg": 58416,
	"./f-key.svg": 85462,
	"./fb.svg": 57494,
	"./feedback-filled.svg": 19516,
	"./feedback-solid.svg": 93953,
	"./feedback.svg": 78723,
	"./file-audio.svg": 37733,
	"./file-import.svg": 96414,
	"./file-text.svg": 66444,
	"./file.svg": 74676,
	"./flag-checkered.svg": 17365,
	"./flip-horizontal.svg": 22972,
	"./flip-vertical.svg": 5962,
	"./folder-user.svg": 66494,
	"./folder.svg": 10486,
	"./gg.svg": 25496,
	"./gif.svg": 8700,
	"./globe.svg": 22701,
	"./google-drive.svg": 89060,
	"./google-slide-dark.svg": 78539,
	"./google-slide.svg": 97771,
	"./google-slides-brand-b.svg": 61151,
	"./google-slides-brand-w.svg": 53522,
	"./google-slides-icon.svg": 76476,
	"./google-slides-round.svg": 13901,
	"./google-slides-w.svg": 88622,
	"./google-slides.svg": 6050,
	"./googleslide.svg": 43622,
	"./grid-4-dots.svg": 24770,
	"./grid-9-dots.svg": 67053,
	"./grid-w.svg": 4466,
	"./grouping-open-ended.svg": 95897,
	"./guess-number.svg": 66590,
	"./h-key.svg": 35216,
	"./hamburger-light.svg": 61468,
	"./hamburger-menu.svg": 28029,
	"./hand-pointer.svg": 52069,
	"./heading-v2-dark.svg": 75998,
	"./heading-v2.svg": 95317,
	"./heading-w.svg": 99484,
	"./heading.svg": 82876,
	"./heart.svg": 25074,
	"./hide.svg": 54238,
	"./hide_correct_answer.svg": 70066,
	"./hide_result.svg": 95610,
	"./hint.svg": 14605,
	"./home.svg": 61895,
	"./hourglass.svg": 23212,
	"./house.svg": 21406,
	"./humorous.svg": 97934,
	"./icon-multiple-language.svg": 37729,
	"./idea.svg": 94231,
	"./idea_suggestion.svg": 1254,
	"./image-choice-w.svg": 91247,
	"./image-choice.svg": 94919,
	"./image-v2-dark.svg": 91979,
	"./image-v2.svg": 5418,
	"./image-w.svg": 42361,
	"./image.svg": 77221,
	"./import-no-background.svg": 31868,
	"./import.svg": 15389,
	"./inb.svg": 80679,
	"./incorrect.svg": 28131,
	"./info-circle-o.svg": 3795,
	"./info-circle.svg": 93059,
	"./information.svg": 12228,
	"./inspiration.svg": 51450,
	"./integration-instructions-rounded.svg": 50490,
	"./integrations.svg": 88271,
	"./invite-v2.svg": 23406,
	"./invite.svg": 83585,
	"./k-button.svg": 86982,
	"./kebab-menu-share.svg": 40177,
	"./kebab-menu.svg": 49423,
	"./key.svg": 56947,
	"./keyboard-enter.svg": 78952,
	"./laptop-and-pc.svg": 57536,
	"./laugh.svg": 93257,
	"./laught.svg": 46343,
	"./leaderboard-dark.svg": 83604,
	"./leaderboard.svg": 56047,
	"./left_direction.svg": 2139,
	"./lengthen.svg": 60911,
	"./lightbulb-v2.svg": 61640,
	"./lightbulb.svg": 30751,
	"./like.svg": 70931,
	"./line-arrow.svg": 70708,
	"./line.svg": 23520,
	"./link-icon.svg": 54608,
	"./list-type.svg": 9707,
	"./list-v2-dark.svg": 69612,
	"./list-v2.svg": 81335,
	"./list-w.svg": 51750,
	"./list.svg": 99626,
	"./lock-sub.svg": 46542,
	"./lock.svg": 16567,
	"./lockv2.svg": 43155,
	"./log-out-v2.svg": 5324,
	"./logo-full.svg": 57671,
	"./logo-icon-only.svg": 47538,
	"./logo-loader.svg": 67633,
	"./logo.svg": 92623,
	"./logout.svg": 61391,
	"./magic-slide.svg": 12443,
	"./magic-wand-colored.svg": 90707,
	"./magic-wand.svg": 41446,
	"./mail.svg": 15803,
	"./match-pairs-v2-dark.svg": 13263,
	"./match-pairs-v2.svg": 13814,
	"./match-pairs-w.svg": 41485,
	"./match-pairs.svg": 34537,
	"./meta-key.svg": 55239,
	"./microsoft.svg": 68734,
	"./minus.svg": 15690,
	"./miro-w.svg": 87617,
	"./miro.svg": 80541,
	"./more.svg": 88697,
	"./move.svg": 71037,
	"./ms-teams.svg": 60375,
	"./mti-check.svg": 3841,
	"./mti-comment.svg": 17054,
	"./mti-content.svg": 38530,
	"./mti-type-answer-w.svg": 93862,
	"./mti-type-answer.svg": 4394,
	"./multiple-choice-w.svg": 56034,
	"./multiple-choice.svg": 38326,
	"./music-note.svg": 82128,
	"./music.svg": 36200,
	"./name.svg": 53235,
	"./newfolder.svg": 47880,
	"./no-presentation.svg": 50271,
	"./no-result.svg": 64471,
	"./notch-circle.svg": 75953,
	"./note-side-left-fill.svg": 57810,
	"./note-side-left.svg": 71736,
	"./note.svg": 34394,
	"./one-by-one-w.svg": 81147,
	"./one-by-one.svg": 66691,
	"./open-ended-v2-dark.svg": 80175,
	"./open-ended-v2.svg": 52406,
	"./open-ended-w.svg": 82509,
	"./open-ended.svg": 52649,
	"./open-new-window.svg": 55224,
	"./paint.svg": 12314,
	"./palette-2.svg": 29154,
	"./palette.svg": 62263,
	"./paste.svg": 35295,
	"./pause.svg": 84564,
	"./payment-v2.svg": 50889,
	"./payment.svg": 67704,
	"./pen.svg": 4719,
	"./pending.svg": 14895,
	"./people-group.svg": 82133,
	"./people.svg": 84523,
	"./phone-o.svg": 91842,
	"./phone-share.svg": 18080,
	"./phone.svg": 96078,
	"./phosphor-Gear.svg": 27125,
	"./phosphor-Info.svg": 51864,
	"./phosphor-MagicWand.svg": 16155,
	"./phosphor-MusicNotesSimple.svg": 55186,
	"./phosphor-Palette.svg": 99710,
	"./phosphor-PencilSimpleLine.svg": 43075,
	"./phosphor-Sparkle.svg": 98954,
	"./phosphor-WarningCircle.svg": 56412,
	"./phosphor-error.svg": 30817,
	"./phosphor-success.svg": 23101,
	"./pick-answer-v2-dark.svg": 92622,
	"./pick-answer-v2.svg": 23909,
	"./pick-answer-w.svg": 57132,
	"./pick-answer.svg": 78892,
	"./pick-image-w.svg": 78097,
	"./pick-image.svg": 19789,
	"./piechart-w.svg": 42016,
	"./piechart.svg": 43680,
	"./pin-on-image.svg": 19439,
	"./plan.svg": 11571,
	"./play.svg": 62236,
	"./plus-new.svg": 56119,
	"./plus.svg": 9154,
	"./poll-colored.svg": 23980,
	"./poll-v2-dark.svg": 8911,
	"./poll-v2.svg": 82678,
	"./poll.svg": 51337,
	"./polygon.svg": 82164,
	"./ppt-add-in.svg": 73776,
	"./present.svg": 70215,
	"./presentation-chart.svg": 5029,
	"./presentations.svg": 42957,
	"./presenter-light.svg": 64734,
	"./presenter-solid.svg": 67384,
	"./presenter.svg": 13594,
	"./professsional.svg": 32386,
	"./profile-light-dark.svg": 47071,
	"./profile-light.svg": 80582,
	"./profile-solid.svg": 7747,
	"./profile.svg": 30781,
	"./profile_info.svg": 59916,
	"./profile_logout.svg": 69461,
	"./profile_terms.svg": 7073,
	"./profile_tutorial.svg": 21950,
	"./q&a-w.svg": 78516,
	"./qa.svg": 55912,
	"./qna-colored.svg": 50769,
	"./qna-dark.svg": 33761,
	"./qna.svg": 7836,
	"./qr-code-w.svg": 56387,
	"./qr-code.svg": 28347,
	"./qr-code2.svg": 33507,
	"./qr-dark.svg": 23096,
	"./qr.svg": 42603,
	"./question-o.svg": 77082,
	"./question-top-bar.svg": 88364,
	"./question-v2.svg": 32155,
	"./question.svg": 45734,
	"./quiz-answer.svg": 22776,
	"./rating-scale-dark.svg": 78917,
	"./rating-scale.svg": 38872,
	"./received-checked.svg": 26783,
	"./reconnecting.svg": 7567,
	"./redo.svg": 55174,
	"./reload.svg": 30565,
	"./remove.svg": 39346,
	"./replay.svg": 49671,
	"./reposition.svg": 66428,
	"./request.svg": 46605,
	"./reset.svg": 37311,
	"./restore.svg": 85144,
	"./return-key.svg": 91318,
	"./review-slides.svg": 97149,
	"./ribbon-star.svg": 2047,
	"./right_direction.svg": 54254,
	"./rotate-left.svg": 10719,
	"./rotate-right.svg": 35674,
	"./sad.svg": 11602,
	"./save.svg": 17293,
	"./scales-w.svg": 6371,
	"./scales.svg": 6747,
	"./search.svg": 32534,
	"./selected-hint.svg": 38237,
	"./send-backward.svg": 48550,
	"./send-button.svg": 6453,
	"./send-rotate.svg": 64244,
	"./send-to-back.svg": 82918,
	"./send.svg": 86944,
	"./setting-top-bar.svg": 73104,
	"./setting.svg": 14362,
	"./shape-circle.svg": 62730,
	"./shape-square.svg": 64111,
	"./shape-star.svg": 95794,
	"./shape-triangle.svg": 9138,
	"./shape.svg": 54749,
	"./share-collab.svg": 81823,
	"./share-new.svg": 39782,
	"./share-v2.svg": 11476,
	"./share.svg": 60003,
	"./shared-folder.svg": 69178,
	"./shift-key.svg": 92940,
	"./short-answer-dark.svg": 99164,
	"./short-answer.svg": 11623,
	"./shorten.svg": 29605,
	"./show_correct_answer.svg": 84535,
	"./show_result.svg": 1099,
	"./shuffle.svg": 4217,
	"./slide.svg": 35509,
	"./slides.svg": 36252,
	"./sparkles-black.svg": 137,
	"./sparkles-outline.svg": 18826,
	"./sparkles-white.svg": 41951,
	"./sparkles.svg": 30095,
	"./spellchecker.svg": 67921,
	"./spinner-wheel-bg-dark-v2.svg": 96243,
	"./spinner-wheel-bg-dark.svg": 10110,
	"./spinner-wheel-bg-white-v2.svg": 36886,
	"./spinner-wheel-bg-white.svg": 96969,
	"./spinner-wheel-colored.svg": 25790,
	"./spinner-wheel-v2-dark.svg": 15129,
	"./spinner-wheel-v2.svg": 48644,
	"./spinner-wheel-w.svg": 71115,
	"./spinner-wheel.svg": 72275,
	"./spinner.svg": 67913,
	"./squares-four.svg": 64691,
	"./star-fill.svg": 48888,
	"./star-half.svg": 91636,
	"./stop-dark.svg": 50975,
	"./stopwatch.svg": 39019,
	"./streak.svg": 55608,
	"./template.svg": 6068,
	"./tenor.svg": 86888,
	"./terms.svg": 42507,
	"./text.svg": 41683,
	"./thin-open-window.svg": 1985,
	"./thumb-up.svg": 83336,
	"./timer.svg": 13745,
	"./trash-new.svg": 10685,
	"./trash.svg": 80664,
	"./trophy-colored.svg": 13553,
	"./trophy-outlined.svg": 18979,
	"./trophy.svg": 3932,
	"./tutorial.svg": 48788,
	"./tutorial_video.svg": 64176,
	"./type-answer-w.svg": 88329,
	"./type-answer.svg": 5461,
	"./type-image.svg": 55326,
	"./undo.svg": 31360,
	"./unhide.svg": 70275,
	"./unlock.svg": 90298,
	"./unlockv2.svg": 8410,
	"./unsplash.svg": 93958,
	"./up_direction.svg": 92747,
	"./upload-image.svg": 81201,
	"./user-solid.svg": 90349,
	"./users-v2.svg": 69699,
	"./users.svg": 17742,
	"./v-key.svg": 99718,
	"./video.svg": 56403,
	"./videos.svg": 41210,
	"./warn-circle-o.svg": 76459,
	"./warning-circle.svg": 59303,
	"./warning.svg": 66170,
	"./whats-new.svg": 16238,
	"./whats-new_red.svg": 78106,
	"./wheel-background.svg": 73576,
	"./wider-than-1180px.svg": 2656,
	"./word-cloud-grouping.svg": 16116,
	"./word-cloud-v2-dark.svg": 46096,
	"./word-cloud-v2.svg": 38291,
	"./word-cloud-w.svg": 23482,
	"./word-cloud.svg": 83646,
	"./wow.svg": 72735,
	"./x-key.svg": 7328,
	"./youtube-v2-dark.svg": 15435,
	"./youtube-v2.svg": 23210,
	"./youtube-w.svg": 95609,
	"./youtube.svg": 45541,
	"./z-key.svg": 69074,
	"./zoom-in.svg": 37809,
	"./zoom-out.svg": 30720,
	"./zoom.svg": 55763,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/CaretRight.svg": 63943,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/Excel.svg": 84527,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/PowerPoint.svg": 93609,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/Teams.svg": 97232,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/add-colored.svg": 53198,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/add.svg": 46019,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-asterisk.svg": 70503,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-backstage.svg": 55928,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-bell.svg": 27660,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-chart.svg": 89893,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-chat-circle.svg": 64826,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-click.svg": 71817,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-close.svg": 55773,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-device-mobile.svg": 55832,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-dots-vertical.svg": 44198,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-drag.svg": 40045,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-duplicate.svg": 35502,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-edit.svg": 20751,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-eye-slash.svg": 42490,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-fire.svg": 56447,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-globe-simple.svg": 72097,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-hand-pointing.svg": 94183,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-hourglass-high.svg": 37816,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-info.svg": 25267,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-magnifier-v2.svg": 99486,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-magnifier.svg": 37937,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-move.svg": 71104,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-music-notes.svg": 88884,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-play.svg": 31973,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-presentation-chart-first.svg": 37561,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-presentation-chart.svg": 85864,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-question.svg": 19427,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-question2.svg": 88411,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-remote.svg": 32261,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-reset.svg": 91244,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-share-network.svg": 20049,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-share.svg": 73508,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-shuffle.svg": 84902,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-sign-out.svg": 74771,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-smiley.svg": 6325,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-trash.svg": 41115,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-user-circle.svg": 52055,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-user-circle2.svg": 81463,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-user-plus.svg": 97939,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-users-three.svg": 6874,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/aha-users.svg": 26421,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/ai-generate-button-disabled.svg": 69282,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/ai-generate-button.svg": 92357,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/ai-sparkle.svg": 80021,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/analytical.svg": 79672,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/answered.svg": 38543,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow-clock-wise-rtl.svg": 10652,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow-clock-wise.svg": 78333,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow-left.svg": 71793,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow-no-tail-black.svg": 43620,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow-no-tail-white.svg": 35874,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow-no-tail.svg": 58790,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow-square-out-v2.svg": 16021,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow-square-out.svg": 17180,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow-tail.svg": 6520,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrow.svg": 42669,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrows-clock-wise.svg": 49234,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/arrows-exchange.svg": 12798,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/audience-feedback.svg": 19860,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/audience.svg": 62872,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/award.svg": 63365,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/b-key.svg": 47258,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/backstage.svg": 21731,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/banned.svg": 68726,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/bar-chart-square.svg": 74246,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/bill-v2.svg": 51782,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/bill.svg": 87321,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/bin-empty.svg": 99817,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/blink.svg": 31264,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/bottom_direction.svg": 12909,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/brainstorm-v2-dark.svg": 20763,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/brainstorm-v2.svg": 96346,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/brainstorm-white.svg": 4425,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/brainstorm.svg": 93653,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/bring-forward.svg": 54934,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/bring-to-front.svg": 1830,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/c-key.svg": 72731,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/caret-down.svg": 70415,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/categorise-v2-dark.svg": 8008,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/categorise-v2.svg": 53787,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/categorise-white.svg": 62338,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/categorise.svg": 97510,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/change-text-color.svg": 15248,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chat-canvas-noti.svg": 6234,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chat-canvas.svg": 54669,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chat.svg": 96780,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chat2.svg": 18806,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chatGPT-white.svg": 61935,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chatGPT.svg": 15871,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/check-circle-o.svg": 57211,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/check.svg": 5070,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chevron-down-new.svg": 47745,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chevron-down.svg": 38540,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chevron-right-2.svg": 89495,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chevron-right.svg": 10398,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/chevron-up-new.svg": 86842,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-audience-color.svg": 26423,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-audience.svg": 65281,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-check-mark-color.svg": 85795,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-check-mark.svg": 88669,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-check-with-border.svg": 36757,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-check.svg": 13749,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-heart-color.svg": 28663,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-heart.svg": 57281,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-star-color.svg": 32793,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-star.svg": 9355,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-submission-color.svg": 70481,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/circle-submission.svg": 66019,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/clear.svg": 37337,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/clip.svg": 32100,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/close-o.svg": 7454,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/close-round.svg": 16837,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/close-small.svg": 70000,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/close-v2.svg": 71799,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/close.svg": 55306,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/cloud-colored.svg": 32376,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/cloud-import.svg": 50993,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/cloud.svg": 53973,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/coin.svg": 6489,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/comment.svg": 23581,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/community-v2.svg": 62986,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/community.svg": 5669,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/connection-error.svg": 67871,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/connection-good.svg": 22324,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/connection-unstable.svg": 27403,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/content-v2-dark.svg": 76655,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/content-v2.svg": 16662,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/content-w.svg": 90509,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/content.svg": 69193,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/copy-b.svg": 82172,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/copy-icon.svg": 29697,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/copy-regular.svg": 67310,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/copy-to-another-slide.svg": 57799,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/copy-to-workspace.svg": 15761,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/copy.svg": 47661,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/correct-order-v2-dark.svg": 36057,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/correct-order-v2.svg": 27332,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/correct-order-w.svg": 60939,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/correct-order.svg": 49043,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/correct.svg": 69200,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/countdown-timer-w.svg": 13327,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/countdown-timer.svg": 41799,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/creative.svg": 28545,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/ctrl-key.svg": 22291,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/cut.svg": 75038,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/d-key.svg": 82388,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/default-thumbnail.svg": 25130,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/default_direction.svg": 1371,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/delete-key.svg": 94765,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/delete.svg": 86343,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/delete2.svg": 58311,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/dislike.svg": 80135,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/document-dark.svg": 9078,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/document-excel.svg": 63315,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/document-v2-dark.svg": 88371,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/document-v2.svg": 8802,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/document-w.svg": 75105,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/document.svg": 52637,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/documents.svg": 55636,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/dollar-currency-v2.svg": 68437,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/donut-w.svg": 22594,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/donut.svg": 87926,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/down.svg": 63430,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/download-2.svg": 67223,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/download.svg": 59230,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/draw.svg": 73212,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/duplicate.svg": 60897,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/duplicated.svg": 26591,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/edit-2.svg": 32187,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/edit-outline.svg": 24835,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/edit.svg": 94458,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/embed-dark.svg": 95558,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/embed-v2-dark.svg": 16067,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/embed-v2.svg": 2514,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/embed.svg": 69965,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/empty-photo.svg": 30034,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/error-circle-o.svg": 59629,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/error.svg": 63668,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/export-2.svg": 19229,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/export.svg": 58416,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/f-key.svg": 85462,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/fb.svg": 57494,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/feedback-filled.svg": 19516,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/feedback-solid.svg": 93953,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/feedback.svg": 78723,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/file-audio.svg": 37733,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/file-import.svg": 96414,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/file-text.svg": 66444,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/file.svg": 74676,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/flag-checkered.svg": 17365,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/flip-horizontal.svg": 22972,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/flip-vertical.svg": 5962,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/folder-user.svg": 66494,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/folder.svg": 10486,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/gg.svg": 25496,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/gif.svg": 8700,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/globe.svg": 22701,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/google-drive.svg": 89060,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/google-slide-dark.svg": 78539,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/google-slide.svg": 97771,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/google-slides-brand-b.svg": 61151,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/google-slides-brand-w.svg": 53522,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/google-slides-icon.svg": 76476,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/google-slides-round.svg": 13901,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/google-slides-w.svg": 88622,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/google-slides.svg": 6050,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/googleslide.svg": 43622,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/grid-4-dots.svg": 24770,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/grid-9-dots.svg": 67053,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/grid-w.svg": 4466,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/grouping-open-ended.svg": 95897,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/guess-number.svg": 66590,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/h-key.svg": 35216,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/hamburger-light.svg": 61468,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/hamburger-menu.svg": 28029,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/hand-pointer.svg": 52069,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/heading-v2-dark.svg": 75998,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/heading-v2.svg": 95317,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/heading-w.svg": 99484,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/heading.svg": 82876,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/heart.svg": 25074,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/hide.svg": 54238,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/hide_correct_answer.svg": 70066,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/hide_result.svg": 95610,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/hint.svg": 14605,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/home.svg": 61895,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/hourglass.svg": 23212,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/house.svg": 21406,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/humorous.svg": 97934,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/icon-multiple-language.svg": 37729,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/idea.svg": 94231,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/idea_suggestion.svg": 1254,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/image-choice-w.svg": 91247,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/image-choice.svg": 94919,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/image-v2-dark.svg": 91979,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/image-v2.svg": 5418,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/image-w.svg": 42361,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/image.svg": 77221,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/import-no-background.svg": 31868,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/import.svg": 15389,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/inb.svg": 80679,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/incorrect.svg": 28131,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/info-circle-o.svg": 3795,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/info-circle.svg": 93059,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/information.svg": 12228,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/inspiration.svg": 51450,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/integration-instructions-rounded.svg": 50490,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/integrations.svg": 88271,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/invite-v2.svg": 23406,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/invite.svg": 83585,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/k-button.svg": 86982,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/kebab-menu-share.svg": 40177,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/kebab-menu.svg": 49423,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/key.svg": 56947,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/keyboard-enter.svg": 78952,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/laptop-and-pc.svg": 57536,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/laugh.svg": 93257,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/laught.svg": 46343,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/leaderboard-dark.svg": 83604,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/leaderboard.svg": 56047,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/left_direction.svg": 2139,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/lengthen.svg": 60911,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/lightbulb-v2.svg": 61640,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/lightbulb.svg": 30751,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/like.svg": 70931,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/line-arrow.svg": 70708,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/line.svg": 23520,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/link-icon.svg": 54608,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/list-type.svg": 9707,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/list-v2-dark.svg": 69612,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/list-v2.svg": 81335,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/list-w.svg": 51750,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/list.svg": 99626,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/lock-sub.svg": 46542,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/lock.svg": 16567,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/lockv2.svg": 43155,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/log-out-v2.svg": 5324,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/logo-full.svg": 57671,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/logo-icon-only.svg": 47538,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/logo-loader.svg": 67633,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/logo.svg": 92623,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/logout.svg": 61391,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/magic-slide.svg": 12443,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/magic-wand-colored.svg": 90707,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/magic-wand.svg": 41446,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/mail.svg": 15803,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/match-pairs-v2-dark.svg": 13263,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/match-pairs-v2.svg": 13814,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/match-pairs-w.svg": 41485,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/match-pairs.svg": 34537,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/meta-key.svg": 55239,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/microsoft.svg": 68734,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/minus.svg": 15690,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/miro-w.svg": 87617,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/miro.svg": 80541,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/more.svg": 88697,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/move.svg": 71037,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/ms-teams.svg": 60375,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/mti-check.svg": 3841,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/mti-comment.svg": 17054,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/mti-content.svg": 38530,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/mti-type-answer-w.svg": 93862,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/mti-type-answer.svg": 4394,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/multiple-choice-w.svg": 56034,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/multiple-choice.svg": 38326,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/music-note.svg": 82128,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/music.svg": 36200,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/name.svg": 53235,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/newfolder.svg": 47880,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/no-presentation.svg": 50271,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/no-result.svg": 64471,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/notch-circle.svg": 75953,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/note-side-left-fill.svg": 57810,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/note-side-left.svg": 71736,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/note.svg": 34394,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/one-by-one-w.svg": 81147,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/one-by-one.svg": 66691,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/open-ended-v2-dark.svg": 80175,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/open-ended-v2.svg": 52406,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/open-ended-w.svg": 82509,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/open-ended.svg": 52649,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/open-new-window.svg": 55224,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/paint.svg": 12314,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/palette-2.svg": 29154,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/palette.svg": 62263,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/paste.svg": 35295,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pause.svg": 84564,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/payment-v2.svg": 50889,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/payment.svg": 67704,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pen.svg": 4719,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pending.svg": 14895,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/people-group.svg": 82133,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/people.svg": 84523,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phone-o.svg": 91842,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phone-share.svg": 18080,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phone.svg": 96078,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-Gear.svg": 27125,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-Info.svg": 51864,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-MagicWand.svg": 16155,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-MusicNotesSimple.svg": 55186,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-Palette.svg": 99710,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-PencilSimpleLine.svg": 43075,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-Sparkle.svg": 98954,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-WarningCircle.svg": 56412,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-error.svg": 30817,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/phosphor-success.svg": 23101,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pick-answer-v2-dark.svg": 92622,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pick-answer-v2.svg": 23909,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pick-answer-w.svg": 57132,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pick-answer.svg": 78892,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pick-image-w.svg": 78097,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pick-image.svg": 19789,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/piechart-w.svg": 42016,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/piechart.svg": 43680,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/pin-on-image.svg": 19439,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/plan.svg": 11571,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/play.svg": 62236,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/plus-new.svg": 56119,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/plus.svg": 9154,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/poll-colored.svg": 23980,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/poll-v2-dark.svg": 8911,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/poll-v2.svg": 82678,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/poll.svg": 51337,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/polygon.svg": 82164,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/ppt-add-in.svg": 73776,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/present.svg": 70215,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/presentation-chart.svg": 5029,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/presentations.svg": 42957,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/presenter-light.svg": 64734,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/presenter-solid.svg": 67384,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/presenter.svg": 13594,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/professsional.svg": 32386,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/profile-light-dark.svg": 47071,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/profile-light.svg": 80582,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/profile-solid.svg": 7747,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/profile.svg": 30781,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/profile_info.svg": 59916,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/profile_logout.svg": 69461,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/profile_terms.svg": 7073,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/profile_tutorial.svg": 21950,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/q&a-w.svg": 78516,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/qa.svg": 55912,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/qna-colored.svg": 50769,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/qna-dark.svg": 33761,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/qna.svg": 7836,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/qr-code-w.svg": 56387,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/qr-code.svg": 28347,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/qr-code2.svg": 33507,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/qr-dark.svg": 23096,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/qr.svg": 42603,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/question-o.svg": 77082,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/question-top-bar.svg": 88364,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/question-v2.svg": 32155,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/question.svg": 45734,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/quiz-answer.svg": 22776,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/rating-scale-dark.svg": 78917,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/rating-scale.svg": 38872,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/received-checked.svg": 26783,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/reconnecting.svg": 7567,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/redo.svg": 55174,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/reload.svg": 30565,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/remove.svg": 39346,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/replay.svg": 49671,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/reposition.svg": 66428,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/request.svg": 46605,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/reset.svg": 37311,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/restore.svg": 85144,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/return-key.svg": 91318,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/review-slides.svg": 97149,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/ribbon-star.svg": 2047,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/right_direction.svg": 54254,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/rotate-left.svg": 10719,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/rotate-right.svg": 35674,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/sad.svg": 11602,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/save.svg": 17293,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/scales-w.svg": 6371,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/scales.svg": 6747,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/search.svg": 32534,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/selected-hint.svg": 38237,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/send-backward.svg": 48550,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/send-button.svg": 6453,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/send-rotate.svg": 64244,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/send-to-back.svg": 82918,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/send.svg": 86944,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/setting-top-bar.svg": 73104,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/setting.svg": 14362,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/shape-circle.svg": 62730,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/shape-square.svg": 64111,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/shape-star.svg": 95794,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/shape-triangle.svg": 9138,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/shape.svg": 54749,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/share-collab.svg": 81823,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/share-new.svg": 39782,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/share-v2.svg": 11476,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/share.svg": 60003,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/shared-folder.svg": 69178,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/shift-key.svg": 92940,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/short-answer-dark.svg": 99164,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/short-answer.svg": 11623,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/shorten.svg": 29605,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/show_correct_answer.svg": 84535,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/show_result.svg": 1099,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/shuffle.svg": 4217,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/slide.svg": 35509,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/slides.svg": 36252,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/sparkles-black.svg": 137,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/sparkles-outline.svg": 18826,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/sparkles-white.svg": 41951,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/sparkles.svg": 30095,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spellchecker.svg": 67921,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner-wheel-bg-dark-v2.svg": 96243,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner-wheel-bg-dark.svg": 10110,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner-wheel-bg-white-v2.svg": 36886,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner-wheel-bg-white.svg": 96969,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner-wheel-colored.svg": 25790,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner-wheel-v2-dark.svg": 15129,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner-wheel-v2.svg": 48644,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner-wheel-w.svg": 71115,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner-wheel.svg": 72275,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/spinner.svg": 67913,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/squares-four.svg": 64691,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/star-fill.svg": 48888,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/star-half.svg": 91636,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/stop-dark.svg": 50975,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/stopwatch.svg": 39019,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/streak.svg": 55608,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/template.svg": 6068,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/tenor.svg": 86888,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/terms.svg": 42507,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/text.svg": 41683,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/thin-open-window.svg": 1985,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/thumb-up.svg": 83336,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/timer.svg": 13745,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/trash-new.svg": 10685,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/trash.svg": 80664,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/trophy-colored.svg": 13553,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/trophy-outlined.svg": 18979,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/trophy.svg": 3932,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/tutorial.svg": 48788,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/tutorial_video.svg": 64176,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/type-answer-w.svg": 88329,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/type-answer.svg": 5461,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/type-image.svg": 55326,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/undo.svg": 31360,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/unhide.svg": 70275,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/unlock.svg": 90298,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/unlockv2.svg": 8410,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/unsplash.svg": 93958,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/up_direction.svg": 92747,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/upload-image.svg": 81201,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/user-solid.svg": 90349,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/users-v2.svg": 69699,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/users.svg": 17742,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/v-key.svg": 99718,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/video.svg": 56403,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/videos.svg": 41210,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/warn-circle-o.svg": 76459,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/warning-circle.svg": 59303,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/warning.svg": 66170,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/whats-new.svg": 16238,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/whats-new_red.svg": 78106,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/wheel-background.svg": 73576,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/wider-than-1180px.svg": 2656,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/word-cloud-grouping.svg": 16116,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/word-cloud-v2-dark.svg": 46096,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/word-cloud-v2.svg": 38291,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/word-cloud-w.svg": 23482,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/word-cloud.svg": 83646,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/wow.svg": 72735,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/x-key.svg": 7328,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/youtube-v2-dark.svg": 15435,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/youtube-v2.svg": 23210,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/youtube-w.svg": 95609,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/youtube.svg": 45541,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/z-key.svg": 69074,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/zoom-in.svg": 37809,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/zoom-out.svg": 30720,
	"@mindthegapstudio/stpancras-storybook-app/src/assets/icons/zoom.svg": 55763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42613;